import React, { useMemo } from 'react'
import { IconButton, useTheme } from '@mui/material'
import { ArrowLeftDoubleS, ArrowRightDoubleS } from 'icons'
import { avatarSideBarClasses } from './styles'
import type { ArrowIconProps } from './types'

const ArrowIcon: React.FC<ArrowIconProps> = ({ open, onClick, testId }) => {
  const { palette } = useTheme()

  const Icon = useMemo(
    () => (open ? <ArrowLeftDoubleS fill={palette.primary.main} /> : <ArrowRightDoubleS fill={palette.primary.main} />),
    [open, palette.primary.main],
  )

  return (
    <IconButton onClick={onClick} sx={[avatarSideBarClasses.iconButton]} disableRipple data-testid={testId}>
      {Icon}
    </IconButton>
  )
}

export default ArrowIcon
